import React, { Component } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import RadioQuestion from "../../components/RadioQuestion";
import ScrollToTop from "../../components/utils/ScrollToTop";
import { YES_NO_OPTIONS } from "../../constants";
import Image from "../../components/Image";
import imageCatAndHousePlant from "../../images/cat-and-houseplant.png";
import JunoMoneyDetails from "../../components/JunoMoneyDetails";

class BuyingMoneySources extends Component {
  constructor(props) {
    super(props);

    if (this.props.purchaseMoneySources) {
      const details = this.props.purchaseMoneySources;
      this.state = {
        highRiskCountry: details.highRiskCountry,
        usingCrypto: details.usingCrypto,
        errors: {},
        errorMessages: {
          highRiskCountry: "Let us know if using money from any of the listed countries",
          usingCrypto: "Let us know if you are using crypto",
        },
      };
    } else {
      this.state = {
        highRiskCountry: null,
        usingCrypto: null,
        errors: {},
        errorMessages: {
          highRiskCountry: "Let us know if using money from any of the listed countries",
          usingCrypto: "Let us know if you are using crypto",
        },
      };
    }
  }

  handleValidation() {
    const fields = { ...this.state };
    const errorMessages = { ...this.state.errorMessages };

    let errors = {};
    let formIsValid = true;

    if (fields["highRiskCountry"] === null) {
      const field = "highRiskCountry";
      formIsValid = false;
      errors[field] = errorMessages[field];
    }

    if (fields["usingCrypto"] === null) {
      const field = "usingCrypto";
      formIsValid = false;
      errors[field] = errorMessages[field];
    }

    this.setState({ errors });
    return formIsValid;
  }

  handleFieldValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    this.setState((prevState) => {
      let errors = { ...prevState.errors };
      const errorMessages = { ...prevState.errorMessages };

      if (!isBlur) {
        errors[field] = null;
      } else {
        if (!prevState[field]) {
          errors[field] = errorMessages[field];
        }
      }

      return { errors };
    });
  };

  selectHighRiskCountry = (b) => {
    this.setState({ highRiskCountry: b });
  };

  selectUsingCrypto = (b) => {
    this.setState({ usingCrypto: b });
  };

  shouldReject = () => {
    return this.state.highRiskCountry || this.state.usingCrypto;
  };

  savePurchaseMoneySources = (event) => {
    event.preventDefault();
    if (this.handleValidation()) {
      this.props.onStepComplete({
        purchaseMoneySources: {
          highRiskCountry: this.state.highRiskCountry,
          usingCrypto: this.state.usingCrypto,
        },
        shouldReject: this.shouldReject(),
      });
      return;
    }
  };

  render() {
    return (
      <React.Fragment>
        <ScrollToTop />
        <Card title="Where your money’s coming from" removeTopPadding>
          <JunoMoneyDetails />

          <RadioQuestion
            question="Are you buying this property using money from China, Hong Kong, or the UAE (inc Dubai and Abu Dhabi)?"
            hint="This includes money and gifts transferred from any of these locations to a UK bank account."
            options={YES_NO_OPTIONS}
            inline={true}
            name="highRiskCountry"
            selected={this.state.highRiskCountry}
            optionSelected={this.selectHighRiskCountry}
            validate={this.handleFieldValidation("highRiskCountry")}
            validationError={this.state.errors.highRiskCountry ? this.state.errors.highRiskCountry : null}
          />

          <RadioQuestion
            question="Are you buying this property using crypto?"
            hint="This includes cryptocurrency transferred to a UK bank account, or gifts which have been held as crypto."
            options={YES_NO_OPTIONS}
            inline={true}
            name="usingCrypto"
            selected={this.state.usingCrypto}
            optionSelected={this.selectUsingCrypto}
            validate={this.handleFieldValidation("usingCrypto")}
            validationError={this.state.errors.usingCrypto ? this.state.errors.usingCrypto : null}
          />

          <Action onClick={this.savePurchaseMoneySources}>Continue</Action>
        </Card>
        <Image src={imageCatAndHousePlant} />
      </React.Fragment>
    );
  }
}

export default BuyingMoneySources;
